import { useQuery } from "@tanstack/react-query";
import BinApiService from "src/api/BinApiService";
import { binQueryKeys } from "src/components/BinDetails";

export const useBinStateFromDevice = (params: {binId: number, userTimeZoneOffset: number
},
    queryOptions: {
        enabled?: boolean,
        staleTime?: number,
        refetchInterval?: number,
    }
) => {

    return useQuery(binQueryKeys.stateFromDevice(params.binId), async (q) => {
        const binDTO = await BinApiService.getBinDetailFromDevice(params.binId, params.userTimeZoneOffset, q.signal);
        if (binDTO == null) {
            throw new Error("Bin State from device is empty");
        }
        return binDTO;
    }, {
        enabled: queryOptions.enabled,
        refetchInterval: queryOptions.refetchInterval,
        staleTime: queryOptions.staleTime,
        onError: (err) => console.error("problem getting binState from device", err),
    });
};